export { default } from "./IconTile";
